module.exports = __webpack_public_path__ + "static/media/linkedin.cd7d37b7.png";